class Search {
    constructor() {
    }

    init() {
        // Run it initially
        this._moveSearchFieldsContent();

        // Run it whenever the window is resized
        window.addEventListener('resize', this._moveSearchFieldsContent);
    }
    _moveSearchFieldsContent() {
        const searchFieldsContent = document.getElementById('search-form-fields');
        const searchFieldsSm = document.getElementById('search-form-fields-sm');
        const searchFieldsLg = document.getElementById('search-form-fields-lg');

        if (!searchFieldsContent || !searchFieldsSm || !searchFieldsLg) {
            return;
        }

        if (window.innerWidth < 1280) {
            if (searchFieldsSm.contains(searchFieldsContent) === false) {
                searchFieldsSm.appendChild(searchFieldsContent);
                searchFieldsLg.innerHTML = '';
            }
        } else {
            if (searchFieldsLg.contains(searchFieldsContent) === false) {
                searchFieldsLg.appendChild(searchFieldsContent);
                searchFieldsSm.innerHTML = '';
            }
        }
    }
}

export default new Search();